;(function($){

  $(window).ready(init);

  function init() {
    var MENU = '.Menu';
    var MENU_TRIGGER = '.Sidepage-menu';
    var MENU_ICON = '.Sidepage-trigger';

    function giveMenuSize(){
      var height = $(window).height();
      var width = $(window).width();

      if(width > 992){
        $(MENU).width(width - 160).height(height - 80);
      } else {
        $(MENU).width(width).height(height);
      }
    }

    function toggleMenu(){
      $(MENU_ICON).toggleClass('menu');
      $(MENU).toggleClass('opened');
    }

    giveMenuSize();

    $(window).on('resize', function(){
      giveMenuSize();
    })

    $(MENU_TRIGGER).on('click', function(){
      toggleMenu();
    })
  }

})(jQuery);
